import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { COMPANY_NAME, LANGUAGES } from '../constants';

// Separate component for navigation items
const NavigationItems = ({ handleClick, t }) => (
  <Nav className="me-auto">
    {['home', 'about', 'contact'].map((section) => (
      <Nav.Link 
        key={section} 
        href={`#${section}`} 
        onClick={(event) => handleClick(event, section)}
        className="nav-link"
      >
        {t[section]}
      </Nav.Link>
    ))}
  </Nav>
);

// Separate component for theme and language toggles
const ToggleButtons = ({ darkMode, setDarkMode, language, setLanguage }) => (
  <div className="d-flex gap-2 align-items-center">
    <Button 
      variant="outline-secondary" 
      onClick={() => setDarkMode(!darkMode)}
      aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
      className="icon-button"
    >
      <i className={`fas fa-${darkMode ? "sun" : "moon"}`}></i>
    </Button>
    <Button 
      variant="outline-secondary" 
      onClick={() => setLanguage(language === LANGUAGES.EN ? LANGUAGES.ID : LANGUAGES.EN)}
      className="language-button"
    >
      {language === LANGUAGES.EN ? "ID" : "EN"}
    </Button>
  </div>
);

function Header({ darkMode, setDarkMode, language, setLanguage, handleScroll, t }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = (event, section) => {
    event.preventDefault();
    handleScroll(section);
  };

  return (
    <header className={scrolled ? 'navbar-scrolled' : ''}>
      <Navbar 
        bg={darkMode ? 'dark' : 'light'} 
        variant={darkMode ? 'dark' : 'light'} 
        expand="lg" 
        className={darkMode ? 'bg-dark' : 'bg-light'}
      >
        <Container>
          <Navbar.Brand href="#home" className="navbar-brand">
            <span className="text-gradient">{COMPANY_NAME}</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <NavigationItems handleClick={handleClick} t={t} />
            <ToggleButtons 
              darkMode={darkMode}
              setDarkMode={setDarkMode}
              language={language}
              setLanguage={setLanguage}
            />
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
